/**
 * Business logo, or an initial placeholder while none is set
 * (docs/ux/screens/BusinessHomeScreen.md, BusinessPublicProfileScreen.md).
 *
 * A plain `<img>` rather than `next/image`, which it used to be. It was already
 * passing `unoptimized`, so the two rendered the same thing, and dropping the
 * import is what lets both frontends share one logo (R22 T12).
 */
export function BusinessLogo({
  logoUrl,
  name,
  size,
}: {
  logoUrl: string | null;
  name: string;
  size: number;
}) {
  if (!logoUrl) {
    return (
      <div
        aria-hidden
        className="flex shrink-0 items-center justify-center rounded-xl bg-brand font-bold text-on-brand"
        style={{ width: size, height: size, fontSize: size / 2.5 }}
      >
        {name.trim().charAt(0).toUpperCase() || "?"}
      </div>
    );
  }
  return (
    <img
      src={logoUrl}
      alt={`${name} logo`}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      className="shrink-0 rounded-xl border border-line object-cover"
      style={{ width: size, height: size }}
    />
  );
}
